module.exports = __webpack_public_path__ + "static/media/banner_finance.0b8a8086.png";